// src/pages/PublicPage/BannerOnlyPage.js
import React from "react";
import styled from "styled-components";

const MenuBanner = () => {
  return (
    <Banner>
      <Content>
        <h1>KHÁM PHÁ THỰC ĐƠN ĐA DẠNG</h1>
        <p>
          Hàng trăm gợi ý bữa ăn phong phú & cân đối dinh dưỡng – bắt đầu ngay!
        </p>
        {/* <Action onClick={() => navigate("/menus")}>
            XEM THỰC ĐƠN
          </Action> */}
      </Content>
    </Banner>
  );
};

export default MenuBanner;

/* ---------- styled-components ---------- */
const Banner = styled.div`
  position: relative;
  height: 400px;
  background-image: url("/images/banner-food.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    height: 250px;
    border-radius: 15px;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.35); /* Màu phủ mờ - có thể thay đổi độ đậm */
    z-index: 1;
  }

  > * {
    position: relative;
    z-index: 2;
  }
`;

const Content = styled.div`
  max-width: 760px;
  text-align: center;
  color: white;
  padding: 1.5rem;
  animation: fadeIn 0.9s ease-in;

  h1 {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
    text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.35);
  }

  p {
    font-size: 1.25rem;
    margin-bottom: 2rem;
    line-height: 1.6;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(15px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2rem;
    }
    p {
      font-size: 1rem;
    }
  }
`;
